import { useRef, useState, useEffect } from 'react'
import styles from 'styles/SlideContainer.module.css'
import "reveal.js/dist/reveal.css";
import "styles/externalLibraryOverride.css";

import GreetingScreen from 'screens/GreetingScreen';

import mascotWaving from 'assets/images/common/mascotWaving.gif';
import imageTile from 'assets/images/common/imageTile.gif';
import avatarIntro from 'assets/images/common/avatarIntro.gif';
import poseTime from 'assets/images/common/poseTime.svg';
import wellDone from 'assets/images/common/wellDone.svg';
import whitehatjrLogo from 'assets/images/common/whitehatjrLogo.png';
import optionalActivity from 'assets/images/common/optionalActivity.gif';

import _ from 'lodash'
import ImagePlaceHolder from 'components/ui/ImagePlaceHolder';
import SectionIntroScreen from 'screens/SectionIntroScreen';
import CharacterSelectionScreen from 'screens/CharacterSelectionScreen';
import TextBannerScreen from 'screens/TextBannerScreen';
import CharacterStylesScreen from 'screens/CharacterStylesScreen';
import CharacterAccessoriesScreen from 'screens/CharacterAccessoriesScreen';
import DownloadScreen from 'screens/DownloadScreen';
import AnimateScreen from 'screens/AnimateScreen';
import UploadWickScreen from 'screens/UploadWickScreen';
import UploadMp4Screen from 'screens/UploadMp4Screen';
import VideoScreen from 'screens/VideoScreen';
import UpcomingScreen from 'screens/UpcomingScreen';
import WhiteHatJrScreen from 'screens/WhiteHatJrScreen';
import { optionalActivityFile } from 'utils';
import RemoveBgAnimalSelectionScreen from 'screens/RemoveBgAnimalSelectionScreen';
import PoseTimeScreen from 'screens/PoseTimeScreen';
import { wrapUpAssets } from 'assets/images/WrapUpScreen';
import WrapUpScreen from 'screens/WrapUpScreen';
import StudentNameScreen from 'screens/StudentNameScreen';


type SlideContainerProps = {
  firebaseRef: any;
  firebaseStorage: any;
  teacher: { id: string; name: string };
  student: { id: string; name: string };
  studentNickNameRef: any;
  studentNickName: {nickName:{name: string; isFinal: boolean}};
  
  isTeacher: boolean;
  currentState: {
    currentSlideIndex: number,
    selectedAvatar: string,
    selectedAvatarStyle: string,
    selectedAnimal: string,
    selectedAccessories: string[],
    wickOutputUrl: string;
    videoUrl: string;
    studentOutputVideoUrl: string;
    videoPoster: string;
    isVideoProcessing: boolean;
    studentOutputGifUrl: string;
  };
  iframeProps: any;
  isOptionalActivitySkippedRef: any;
  slideIndex: number;
  socketInstance: any;
};

function SlideContainer({
  teacher,
  student,
  isTeacher,
  firebaseRef,
  firebaseStorage,
  currentState,
  // prevLessonData,
  iframeProps,
  isOptionalActivitySkippedRef,
  slideIndex,
  socketInstance,
  studentNickNameRef,
  studentNickName,
}: SlideContainerProps) {
  const videoRef = useRef<any>();
  const [skipScreen, setSkipScreen] = useState<boolean>(false);
  const [studentName, setStudentName] = useState('');

  useEffect(()=> {
    setStudentName(studentNickName.nickName.name || student.name);
  }, [studentNickName.nickName.name, student.name])


  return (
    <div className={`reveal ${styles.revealCustomStyles}`}>
      <div className={`slides ${styles.slidesCustomStyles}`}>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <StudentNameScreen studentNickName={studentNickName} studentNickNameRef={studentNickNameRef} greetingText="Welcome!" />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <GreetingScreen studentName={studentName} greetingText='Hello' mascot={mascotWaving}/>
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <ImagePlaceHolder 
            img={imageTile} 
          />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <SectionIntroScreen
            mascot={avatarIntro} 
            classes={{
            img: styles.wellDoneImg,
            button: styles.sectionIntroButton
            }}
            buttonText='START'
            heading='Design an Avatar'
            isTeacher={isTeacher}
          />
          </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <CharacterSelectionScreen
            firebaseRef={firebaseRef}
            socketInstance={socketInstance}
            selectedAvatar={currentState.selectedAvatar}
            isTeacher={isTeacher}
          />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <TextBannerScreen
            selectedAvatar={currentState.selectedAvatar}
          />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <CharacterStylesScreen
            selectedAvatar={currentState.selectedAvatar}
            firebaseRef={firebaseRef}
            socketInstance={socketInstance}
          />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <TextBannerScreen
            bannerText={`Wait, There's More!`}
          />
        </section> 
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <CharacterAccessoriesScreen
            heading='Select Any Two'
            firebaseRef={firebaseRef}
            selectedAvatar={currentState.selectedAvatar}
            socketInstance={socketInstance}
            remoteSelectedAccessories={currentState.selectedAccessories}
          />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <PoseTimeScreen
             buttonText='SKIP'
             classes={{
              img: styles.poseTimeImg,
              heading: styles.poseTimeHeading,
              button: styles.poseTimeButton
            }}
            mascot={poseTime} 
            slideTo={10}
            setSkipScreen={setSkipScreen}
            isTeacher={isTeacher}
            heading='Pose Time'
            slideIndex={slideIndex}
            socketInstance={socketInstance}
          />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <RemoveBgAnimalSelectionScreen 
            firebaseRef={firebaseRef}
            skipScreen={skipScreen}
            socketInstance={socketInstance}
          />
        </section> 
         <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <DownloadScreen
              selectedAvatar={currentState.selectedAvatar}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <AnimateScreen/>
        </section> 
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <UploadWickScreen
              firebaseRef={firebaseRef}
              studentDetails={student}
              firebaseStorage={firebaseStorage}
              videoRef={videoRef}
              videoUrl={currentState.videoUrl}
              socketInstance={socketInstance}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <DownloadScreen
              selectedAvatar={currentState.selectedAvatar}
              url={currentState.wickOutputUrl}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <AnimateScreen/>
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <UploadMp4Screen
              heading='Upload a GIF'
              firebaseRef={firebaseRef}
              studentDetails={student}
              firebaseStorage={firebaseStorage}
              videoRef={videoRef}
              videoUrl={currentState.videoUrl}
              socketInstance={socketInstance}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <VideoScreen
              videoUrl={currentState.videoUrl}
              videoPoster={currentState.videoPoster}
              videoRef={videoRef}
              studentOutputGifUrl={currentState.studentOutputGifUrl}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <SectionIntroScreen
             mascot={wellDone} 
             classes={{
               img: styles.wellDoneImg
             }}
             heading='Well Done!' 
          />
        </section> 
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <UpcomingScreen
              heading = 'Up Next'
              selectedAvatar={currentState.selectedAvatar}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <WhiteHatJrScreen
            slideTo={24}
            mascot={whitehatjrLogo} 
            buttonText='START'
            isTeacher={isTeacher}
            classes={{
              img: styles.logo
            }}
            isOptionalActivitySkippedRef={isOptionalActivitySkippedRef}
          />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <ImagePlaceHolder 
            heading={`Let's Create!`}
            img={optionalActivity} 
          />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <DownloadScreen
            selectedAvatar={currentState.selectedAvatar}
            url={optionalActivityFile}
          />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <AnimateScreen/>
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <VideoScreen
              heading={`${studentName}'s Creation`}
              videoUrl={currentState.videoUrl}
              videoPoster={currentState.videoPoster}
              videoRef={videoRef}
              studentOutputGifUrl={currentState.studentOutputGifUrl}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              data = {wrapUpAssets[1]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              data = {wrapUpAssets[2]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              data = {wrapUpAssets[3]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              data = {wrapUpAssets[4]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              data = {wrapUpAssets[5]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              data = {wrapUpAssets[6]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              data = {wrapUpAssets[7]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              data = {wrapUpAssets[8]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              data = {wrapUpAssets[9]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              data = {wrapUpAssets[10]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              srcWidthSize = 'wider'
              data = {wrapUpAssets[11]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              isTeacher={isTeacher}
              socketInstance={socketInstance}
              data = {wrapUpAssets[12]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              data = {wrapUpAssets[13]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              data = {wrapUpAssets[14]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              data = {wrapUpAssets[15]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
            <WrapUpScreen
              data = {wrapUpAssets[16]}
            />
        </section>
        <section className={`slide-container ${styles.slideContainerCustomStyles}`} data-transition="">
          <SectionIntroScreen
             mascot={mascotWaving} 
             classes={{
               img: styles.wellDoneImg,
               button: styles.logoStartButton,
               heading: styles.endScreenHeading,
             }}
             heading='See you soon!'
          />
        </section>
      </div>
    </div>
  );
}

export default SlideContainer;
